import React, {FunctionComponent} from "react";
import {sec2hms} from "/src/utils/time-utils";
import {ChallengeUser} from "/src/domain/challenges/ChallengeUser";
import {useTranslation} from "react-i18next";
import makeStyles from "@mui/styles/makeStyles";

export type PredictionsProps = {
    currentUser?: ChallengeUser;
    withPredictions: boolean;
    isRegActive: boolean;
};

export const PredictionsView: FunctionComponent<PredictionsProps> = ({
                                                                         currentUser,
                                                                         withPredictions,
                                                                         isRegActive
                                                                     }) => {
    const classes = useStyles();

    if (!currentUser || !isRegActive || !currentUser?.challengeRegistration?.isRegistered) return null;

    return (
        <div className={classes.container}>
            <UserPredictions withPredictions={withPredictions} currentUser={currentUser}/>
            <UserNostraPredictions currentUser={currentUser}/>
            {Boolean(withPredictions) && <ShowMorePredictions currentUser={currentUser}/>}
        </div>
    )
}

type UserPredictionsProps = {
    currentUser: ChallengeUser
}

const UserPredictions: FunctionComponent<Omit<PredictionsProps, "isRegActive">> = ({currentUser, withPredictions}) => {
    const {t} = useTranslation();
    const classes = useStyles();

    if (!withPredictions || currentUser?.challengeRegistration.predictions.length == 0) return null;

    return (
        <>
            <h4 className={classes.predictionHeader}>{t("predictions")}:</h4>
            <ul className={classes.list}>
                {currentUser?.challengeRegistration.predictions.map((p) => (
                    <li>
                        {`${p.km} ${t("km")} - ${sec2hms(p.sec)}`}
                        <br></br>
                        {`${t("pace")} ${sec2hms(p.pace)} ${t("minKm")}`}
                    </li>
                ))}
            </ul>
        </>
    )
}

const UserNostraPredictions: FunctionComponent<UserPredictionsProps> = ({currentUser}) => {
    const {t} = useTranslation();
    const classes = useStyles();

    if (!Boolean(currentUser.challengeRegistration.predictionNostra)) return null;

    return (
        <div className={classes.predictionNostra}>
                <span className={classes.predictionNostraHeader}>
            {`${t("predictionOutput")} `}
                </span>
            {sec2hms(Number(currentUser.challengeRegistration.predictionNostra))}
        </div>
    )
}

const ShowMorePredictions: FunctionComponent<UserPredictionsProps> = ({currentUser}) => {
    const {t} = useTranslation();
    const classes = useStyles();

    return (
        <a className={classes.link}
           href={`/rating-more?user=${currentUser.stravaId}&showpredictions=1`}>
            {t("showPredictions")}
        </a>
    )
}

const useStyles = makeStyles({
    container: {
        padding: "0 1.5rem",
    },
    header: {
        fontSize: "0.95rem",
    },
    submitButton: {
        width: "100%",
        maxWidth: "30rem",
        margin: "1rem auto",
        display: "block",
    },
    predictionHeader: {
        fontWeight: 400,
        margin: "1rem 0",
        fontSize: "0.95rem",
    },
    list: {
        marginBottom: "0.5rem",
    },
    predictionNostraHeader: {
        fontWeight: 400,
        fontSize: "0.95rem",
    },
    predictionNostra: {
        margin: "1rem 0",
    },
    link: {
        color: "#000",
        width: "100%",
        display: "block",
        marginBottom: "0.5rem",
    },
    form: {
        marginTop: "1rem",
    },
});
